export default function (array, callback, scope) {
    if (array) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]);
        }
    }
};